module.exports = __webpack_public_path__ + "img/brand--plaza-vea.552b7444.png";